import React from 'react';
import { View, Text } from 'react-native';
import PropTypes from 'prop-types';
import { t } from 'Locale';
import { Icon, Button } from 'LocalGluons';
import appManager from 'AppManager';
import defaultStyles from './ClearCache.jss';

const buttonStyle = {
    button: {
        ...defaultStyles.button,
        width: 300
    }
};

const ClearCache = ({ navigation }) => {
    const close = () => {
        navigation.pop();
    };

    const clearCache = () => {
        appManager.wipeCache();
        navigation.pop();
    };

    return (
        <View style={defaultStyles.window}>
            <Icon style={defaultStyles.closeIcon} name="close" onPress={close} />
            <Text style={defaultStyles.title}>{t('COMMON.CLEAR_CACHE_TITLE')}</Text>
            <View style={defaultStyles.line} />
            <Text style={defaultStyles.whiteText}>{t('COMMON.CLEAR_CACHE_TITLE_TXT')}</Text>
            <View style={defaultStyles.buttonContainer}>
                <Button
                    style={buttonStyle}
                    isSecondary
                    title={t('COMMON.CANCEL')}
                    onPress={close}
                />
                <Button
                    style={buttonStyle}
                    title={t('COMMON.CLEAR_CACHE_BTN')}
                    onPress={clearCache}
                />
            </View>
        </View>
    );
};

ClearCache.propTypes = {
    navigation: PropTypes.shape({}).isRequired
};

export default ClearCache;
